<script setup lang="ts">
import { UiIcon } from "@shopexperts/shared";

defineProps<{
    placeholder: string;
}>();

const model = defineModel<string>({ required: true });
</script>

<template>
    <div class="relative w-full sm:w-[260px]">
        <div class="absolute left-3 top-1/2 -translate-y-1/2">
            <UiIcon name="search" class="w-5 h-5 text-se-gray-500" />
        </div>
        <input
            v-model="model"
            type="text"
            :placeholder="placeholder"
            class="w-full h-9 pl-10 pr-3 py-1 border border-se-gray-300 rounded bg-white text-sm focus:outline-none focus:ring-2 focus:ring-se-primary"
        />
    </div>
</template>
